
export const environment = {
    production: false,
    api: {
        consumer: "/consumer/api/v1",
        backoffice: "/backoffice/api/v1",
        user: "/user/api/v1",
        mock: "/be-mock/api/v1"
    },
    keycloak: {
        url: 'https://dev.fadpe.elvoon.it/keycloak',
        realm: 'fadpe',
        clientId: 'fadpe-console',
    }
};
